import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { UserService } from './services/user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    public title = `${environment.extension} Extension`;

    constructor(private userService: UserService) {}

    ngOnInit() {
        console.log('Initializing extensions app with environment:', environment);

        this.userService.checkAndSetIfAuthenticated();
    }
}
